/**
 * Which half of the journey something belongs to.
 *
 * `J1`/`J2` are the search response's own keys (`cards.J1`, `cards.J2`), kept
 * verbatim so nothing has to translate between the wire and the UI. A one-way
 * is simply a journey with only `J1` — there is no separate concept for it, and
 * that is what lets the round-trip layout be "the one-way layout, twice".
 */
export const JOURNEY_LEG = { ONWARD: 'J1', RETURN: 'J2' } as const
export type JourneyLeg = (typeof JOURNEY_LEG)[keyof typeof JOURNEY_LEG]

export const FLIGHTS_AT_SAME_PRICE = 'Flights at same price'
export const HIDE_SAME_PRICE_OPTIONS = 'Hide options'
export const samePriceMoreOptionsLabel = (count: number) => `+${count} more options at same price`

export const HIDE_OPTIONS = 'Hide options'
export const highRpsStartingFromLabel = (priceLabel: string) => `Lowest price starting from ${priceLabel}`
export const highRpsMoreOptionsLabel = (count: number) => `+${count} more options`

const TAG_PRIORITY_REMAINDER = [
  'refundable',
  'nonRefundable',
  'visaRejectionCover',
  'nearbyAirport',
] as const

export const TAG_PRIORITY_ORDER_DOM = [
  'studentFare',
  'handBaggage',
  'ctUpgrade',
  'onTimePerformance',
  'selfTransfer',
  'terminalChange',
  'transitVisa',
  'operatedBy',
  ...TAG_PRIORITY_REMAINDER,
] as const

export const TAG_PRIORITY_ORDER_INTL = [
  'studentFare',
  'handBaggage',
  'transitVisa',
  'selfTransfer',
  'terminalChange',
  'ctUpgrade',
  'onTimePerformance',
  'operatedBy',
  ...TAG_PRIORITY_REMAINDER,
] as const

export const MAX_TUPLE_TAGS = 3

// export const onTimeTagLabel = (percent: number) => `${percent}% on time` // OTP
